<template>
  <div class="nav">
    <div class="ak-nav-title">网管系统</div>

    <div class="ak-nav-content-data" @click="logout">退出</div>
    <div v-popover:popover1 class="ak-nav-content-data">
      <i class="el-icon-user-solid"></i>
      <label style="margin-left:5px;">{{ fullName }}</label>
    </div>
    <el-popover placement="bottom" ref="popover1" width="150" trigger="click">
      <ul class="modify">
        <li @click="openInfo">个人信息</li>
        <li @click="openPw">修改密码</li>
      </ul>
    </el-popover>
    <div class="ak-nav-content-data" @click="openHelp">帮助</div>
    <PasswdBox v-if="openPwBlock" @close="close"></PasswdBox>
    <InfoBox v-if="openInfoBlock" @close="close"></InfoBox>
  </div>
</template>

<script>
import PasswdBox from "./PasswdBox.vue";
import InfoBox from "./InfoBox.vue";
export default {
  components: {
    PasswdBox,
    InfoBox
  },
  data() {
    return {
      userData: {},
      alertPw: false,
      alertName: false,
      fullName: " ",
      openPwBlock: false,
      openInfoBlock: false
    };
  },
  mounted() {
    this.fullName = localStorage.getItem("username");
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("id");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
      localStorage.removeItem("mobile");
      localStorage.removeItem("department");
      localStorage.removeItem("macRecord");
      localStorage.removeItem("ipRecord");
      this.$router.push("/login");
    },
    openPw() {
      this.openPwBlock = true;
    },
    openInfo() {
      this.openInfoBlock = true;
    },
    close() {
      this.openPwBlock = false;
      this.openInfoBlock = false;
    },
    openHelp() {
      window.open(`/help.html`);
    }
  }
};
</script>

<style lang="less" scoped>
.nav {
  background-color: #303133;
  height: 100%;
  .ak-nav-title {
    display: inline-block;
    cursor: pointer;
    color: white;
    text-align: left;
    line-height: 74px;
    margin-left: 55px;
    font-size: 30px;
  }
  .ak-nav-content-data {
    display: inline-block;
    cursor: pointer;
    margin-right: 20px;
    color: white;
    text-align: left;
    line-height: 74px;
    float: right;
  }
}
ul.modify {
  width: calc(~"100% + 20px");
  list-style: none;
  margin-left: -10px;
  li {
    font-size: 0.9rem;
    line-height: 30px;
    height: 30px;
    color: gray;
    cursor: pointer;
    padding-left: 20px;
    font-weight: bold;
  }
  li:hover {
    background-color: #303133;
    color: white;
  }
}
</style>
